define('core/views/VotersCard',[
    'underscore',
    'core/views/common/HoverCard',
    'core/views/UsersCard',
    'core/utils',
], function (
    _,
    HoverCard,
    UsersCard,
    utils
) {
    'use strict';

    var handler = utils.preventDefaultHandler;

    // VotersCard shows list of users who upvoted some particular comment
    var VotersCard = UsersCard.extend({
        guestTextPartialName: 'cardGuestVoterText',

        initialize: function (options) {
            this.voteType = options.voteType;
            var model = options.model;
            var collection = this.voteType === 1 ? model.getUpvotersUserCollection() : model.getDownvotersUserCollection();

            _.extend(options, {
                collection: collection,
                numUsers: this.voteType === 1 ? model.get('likes') : model.get('dislikes'),
            });

            UsersCard.prototype.initialize.call(this, options);

            this.model = model;
            this.session = options.session;
            this.likes = model.get('likes');
            this.dislikes = model.get('dislikes');
            this.hadLikes = Boolean(this.likes);  // preserve initial state of likes
            this.hadDislikes = Boolean(this.dislikes);  // preserve initial state of dislikes

            this._fetched = false;
            this._rendered = false;

            this.listenTo(this.model, 'change:userScore', this.updateUserSet);
            if (this.voteType === 1)
                this.listenTo(this.model, 'change:likes', this.updateGuests);
            else
                this.listenTo(this.model, 'change:dislikes', this.updateGuests);
        },

        updateGuests: function () {
            // Update the value of numUsers to remain synced with likes
            // when the value of likes has changed.
            this.numUsers = (this.voteType === 1 ? this.model.get('likes') : this.model.get('dislikes')) || 0;
            UsersCard.prototype.updateGuests.call(this);
        },

        // Updates the set of users to contain/not contain the session user
        // based on his current vote status for this post.
        updateUserSet: function () {
            var user = this.session.user;

            var hadLikes = this.likes;
            var hadDislikes = this.dislikes;
            var heightIncrease = false;

            this.likes = this.model.get('likes');
            this.dislikes = this.model.get('dislikes');

            // add or remove current user from the list
            if (this.model.get('userScore') === this.voteType) {
                // users collection should not contain Guest users
                // NOTE: Backbone ignores duplicate adds by default (we want this)
                if (this.session.isLoggedIn())
                    this.collection.add(user);

                // update list visibility depending on absence/presence of likes
                if ((this.voteType === 1 && this.likes && !hadLikes) || (this.voteType === -1 && this.dislikes && !hadDislikes)) {
                    this._rendered = false;
                    this.show();
                } else { // if there were some likes previously, just add current user
                    // height will increase when we either add current user or
                    // if current user is a Guest and there are no guets upvotes yet
                    heightIncrease = this.session.isLoggedOut() ?
                        true : Boolean((this.voteType === 1 ? this.likes : this.dislikes) - 1 - this.collection.length);
                }
            } else {
                this.collection.remove(user);
                // if there is no likes - tooltip should be hidden
                if ((this.voteType === 1 && !this.likes) || (this.voteType === -1 && !this.dislikes))
                    this.hide();
            }
            this.updateGuests();
            // fix list position after UI changes
            this.moveTo(this.$target, heightIncrease);
        },

        show: function () {
            // if there is no likes - there is no reason to show the card
            // if the card is already visible - there is no need to do something else
            if ((this.voteType === 1 && !this.likes) || (this.voteType === -1 && !this.dislikes) || this.isVisible())
                return;

            // if there was no likes - there is no reason to make another request
            if ((this.voteType === 1 && !this.hadLikes) || (this.voteType === -1 && !this.hadDislikes))
                this._fetched = true;

            // if we haven't fetched data yet - do the request
            if (!this._fetched) {
                this.collection.fetch({ vote: this.voteType })
                    .done(_.bind(function () {
                        this._fetched = true;
                        this.show();
                    }, this));

                return;
            }

            // In case when current user upvoted the comment earlier than data
            // arrives from the server - we should make sure he appears in the
            // list correctly.
            var user = this.session.user;
            if (this.model.get('userScore') === this.voteType && this.session.isLoggedIn() && !this.collection.contains(user))
                this.collection.add(user);

            // show/render list of voters
            UsersCard.prototype.show.call(this);
        },

        handleShowProfile: handler(function (evt) {
            UsersCard.prototype.handleShowProfile.call(this, evt);
        }),

        getTemplateData: function () {
            var data = UsersCard.prototype.getTemplateData.apply(this, arguments);
            return _.extend({}, data, {
                forumId: this.model.get('forum'),
            });
        },

        getUserTemplateData: function () {
            var data = UsersCard.prototype.getUserTemplateData.apply(this, arguments);
            return _.extend({}, data, {
                forumId: this.model.get('forum'),
            });
        },
    }, {
        create: function (options) {
            // Do not create card if we cannot prevent it from being duplicated
            var post = options.model;

            if (!post.has('id'))
                return;

            return HoverCard.create([post.get('id'), '-', options.voteType].join(''), options, 'VotersCard', VotersCard);
        },
    });

    return VotersCard;
});

